import {AppFormRequest} from '../app-form-request';

export class AppFormRequestEdit {

    private form: AppFormRequest;

    constructor(form: AppFormRequest) {
        this.form = form;
        this.init();
    }

    private init() {
        this.form.onLoad(resolve => {
            const params: any = {};

            if (this.form.generic) {
                params['p3'] = this.form.registerId;
            } else {
                params['id'] = this.form.registerId;
            }

            this.form.requestGET
                .response((data) => {
                    if (data[0]) {
                        for (const x in data[0]) {
                            if (data[0].hasOwnProperty(x)) {
                                this.form.model[x] = data[0][x];
                            }
                        }
                    }
                    resolve(true);
                });

            this.form.requestGET
                .cancelablePerform(params);
        });

        this.form.afterLoad(resolve => {
            this.form.requestGET.unsuscribe();
            resolve(true);
        });

        this.form.onUpdate(resolve => {
            this.form.model['@_update_@'] = 0;

            setTimeout(() => {
                delete this.form.model['@_update_@'];
            }, 10);

            resolve(true);
        });

        this.form.beforeSend(resolve => {
            if (this.form.fieldsToSend) {
                for (const x in this.form.model) {
                    if (this.form.model.hasOwnProperty(x)) {
                        let founded = false;

                        this.form.fieldsToSend.forEach(field => {
                            if (field === x) {
                                founded = true;
                            }
                        });

                        if (!founded) {
                            delete this.form.model[x];
                        }
                    }
                }
            }

            resolve(true);
        });

        this.form.onSend(resolve => {
            this.form.requestPUT.safePerform(this.form.model);
            this.form.requestPUT.response(() => {
                resolve(true);
            });
        });

        this.form.onFinish(resolve => {
            setTimeout(() => {
                this.form.requestPUT.unsuscribe();
            }, 1000);
            resolve(true);
        });

    }
}
